import { ADMIN_DASHBOARD } from 'constants/routes';
// Windows resolves the existing Loggo.PNG asset through the lowercase loader path.
// eslint-disable-next-line import/no-unresolved
import logo from 'images/Loggo.png';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import UserAvatar from 'views/account/components/UserAvatar';

const AdminNavigation = () => {
  const { isAuthenticating, profile } = useSelector((state) => ({
    isAuthenticating: state.app.isAuthenticating,
    profile: state.profile
  }));

  return (
    <nav className="navigation navigation-admin">
      <div className="logo admin-brand">
        <Link to={ADMIN_DASHBOARD}>
          <img alt="Logo" src={logo} />
          <span className="admin-brand-copy">
            <strong>TaKKa Admin</strong>
            <small>Management Console</small>
          </span>
        </Link>
      </div>
      <ul className="navigation-menu">
        <li className="navigation-menu-item">
          <UserAvatar
            isAuthenticating={isAuthenticating}
            profile={profile}
          />
        </li>
      </ul>
    </nav>
  );
};

export default AdminNavigation;
